module.exports = __webpack_public_path__ + "static/media/water_bill.3f907277.png";